export function clearAppCacheAndReload() {
  try {
    localStorage.clear();
    sessionStorage.clear();

    if (window.indexedDB) {
      window.indexedDB.databases().then((dbs) => {
        dbs.forEach((db) => {
          if (db.name) {
            window.indexedDB.deleteDatabase(db.name);
          }
        });
      });
    }

    if ("caches" in window) {
      caches.keys().then((names) => {
        names.forEach((name) => caches.delete(name));
      });
    }

    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.getRegistrations().then((regs) => {
        regs.forEach((reg) => reg.unregister());
      });
    }
  } catch (err) {
    console.error("Erro limpando cache:", err);
  }

  window.location.href = "/login";
}
